import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-link-button",
    styleUrls: ["./link-button.component.scss"],
    templateUrl: "./link-button.component.html"
})
export class FUILinkButtonComponent extends FUIButtonComponent{

}
